import { isCustomizationItem } from '../../../types/models';
import { BasketItem } from '../../../types/states';

export const getBasketFilter = (type: 'room' | 'profile') => {
  return (item: BasketItem) => {
    const isCustomization = isCustomizationItem(item.storeItem);
    return type === 'room' ? !isCustomization : isCustomization;
  };
};
